module.exports = __webpack_public_path__ + "202408221624/img/pic_guide_photo_1@2x.86b4a179.png";